import React, { useState } from 'react';
import { motion } from 'motion/react';
import { Circle } from 'lucide-react';
import { HyperText } from './HyperText';

export const LocationMarker = ({ location, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      className="flex items-center gap-2 cursor-pointer group relative"
      onClick={() => onClick(location.id)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Dot container with enhanced glow */}
      <div className="relative">
        {/* Pulsing background glow with tighter radius and higher opacity */}
        <motion.div
          className="absolute inset-0 rounded-full bg-[#FB6415]"
          style={{
            transform: 'scale(1.4)',
            filter: 'blur(4px)',
            opacity: 0.4,
          }}
          animate={{
            scale: isHovered ? [1.4, 1.6, 1.4] : 1.4,
            opacity: isHovered ? [0.4, 0.6, 0.4] : 0.4,
          }}
          transition={{
            duration: isHovered ? 1.5 : 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
        
        {/* Main dot with enhanced visibility */}
        <motion.div
          className="relative z-10"
          animate={{
            scale: isHovered ? 1.2 : 1,
            transition: { duration: 0.2 }
          }}
        >
          <Circle 
            size={12} 
            fill="#FB6415" 
            stroke="none"
            className="drop-shadow-glow-md"
          />
        </motion.div>
      </div>

      {/* Text container */}
      <div className="relative">
        <HyperText 
          isAnimating={isHovered}
          className="!py-0 font-inter text-white/90 text-sm tracking-wider"
        >
          {location.id}
        </HyperText>
      </div>
    </div>
  );
};